<dashboardnav>
  <cradua-company
  [companys]="companys$ | async"
  (company)="onSubmitCompany($event)"
  (deleteCompanyEvent)="onDeleteCompany($event)"
  *ngIf="(isLoadingCompany$ | async ) === false"
  >
</cradua-company>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingCompany$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
